module.exports = __webpack_public_path__ + "static/media/detail22.eade1c74.jpg";